var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInEditorMode)?_c('dr-wrapper',_vm._g(_vm._b({staticClass:"dr-spacer-wrapper"},'dr-wrapper',_vm.$props,false),_vm.wrapOn)):(_vm.isVisible)?_c('v-spacer',{class:_vm.evaluateClasses(_vm.classes)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }